import React, { useState, useEffect, useRef, useMemo } from "react";
// ANT DESIGN COMPONENTS
import { Tooltip } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// CUSTOM HOOKS
import { useLastBankMessage } from "../socketMessageState/BankMessagesContext";
// INTERFACES
import { SocketMessageInterface } from "../../../interfaces/Monitoring.interface";
// CONSTANTS
import { BLANK_SOCKET_MESSAGE } from "../../../constants/monitoring";
// UTILS
import { stringToUuidT } from "../../../utils/uuid";

function MonitoringHeartBeat({ bankId }: { bankId: string }) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const [t] = useTranslation("global");
	const disconnectTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [connected, setConnected] = useState<boolean>(false);

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */
	const bankUuid = useMemo(() => stringToUuidT(bankId), [bankId]);
	const socketMessageBank: SocketMessageInterface = useLastBankMessage(bankUuid) || BLANK_SOCKET_MESSAGE;

	// ************************************************ */
	// HELPERS **************************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// USE MEMO *************************************** */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE CALLBACK *********************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// EFFECT ***************************************** */
	// useEffect(() => {
	// 	if (socketMessageBank.msg.value.toUpperCase() !== "CONNECTED") return;
	// 	const isActive = socketMessageBank.msg.active;

	// 	if (isActive) {
	// 		if (disconnectTimeoutRef.current) {
	// 			clearTimeout(disconnectTimeoutRef.current);
	// 			disconnectTimeoutRef.current = null;
	// 		}

	// 		setConnected(true);
	// 		return;
	// 	}

	// 	if (!isActive) {
	// 		if (!disconnectTimeoutRef.current) {
	// 			disconnectTimeoutRef.current = setTimeout(() => {
	// 				setConnected(false);
	// 				disconnectTimeoutRef.current = null;
	// 			}, 10000);
	// 		}
	// 	}
	// }, [socketMessageBank.msg]);

	useEffect(() => {
		if (socketMessageBank.connected) {
			if (disconnectTimeoutRef.current) {
				clearTimeout(disconnectTimeoutRef.current);
				disconnectTimeoutRef.current = null;
			}
			setConnected(true);
			return;
		}

		if (!disconnectTimeoutRef.current) {
			disconnectTimeoutRef.current = setTimeout(() => {
				setConnected(false);
				disconnectTimeoutRef.current = null;
			}, 10000);
		}
	}, [socketMessageBank.connected]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className='generalStyles__mrFix'>
			{connected ? (
				<Tooltip title={t("monitoring.highTcpConnection")}>
					<FontAwesomeIcon icon={faCircle} className='generalStyles__success' />
				</Tooltip>
			) : (
				<Tooltip title={t("monitoring.lowTcpConnection")}>
					<FontAwesomeIcon icon={faCircle} className='generalStyles__error' />
				</Tooltip>
			)}
		</div>
	);
}

export default React.memo(MonitoringHeartBeat);
